import { Suspense } from 'react';
import Hero from './components/Hero';
import Philosophy from './components/Philosophy';
import WhyCareInsure from './components/WhyCareInsure';
import InsuranceDetails from './components/InsuranceDetails';
import ProductIntro from './components/ProductIntro';
import AccidentCriteria from './components/AccidentCriteria';
import ClaimsProcess from './components/ClaimsProcess';
import PremiumReasons from './components/PremiumReasons';
import PremiumStructure from './components/PremiumStructure';
import EvaluationSupport from './components/EvaluationSupport';
import FAQ from './components/FAQ';
import ConsultationForm from './components/ConsultationForm';
import Footer from './components/Footer';
import FloatingConsultButton from '../../components/feature/FloatingConsultButton';
import { useSEO } from '../../utils/seo';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${siteUrl}#organization`,
    "name": "케어인슈",
    "url": siteUrl,
    "logo": "https://static.readdy.ai/image/b2717fa299e25af1bb585f7256441db5/7de63a456d31e262de55447347492a86.png",
    "description": "장기요양기관을 위한 전문 배상책임보험 서비스. 맞춤형 보험 설계와 신속한 사고 처리로 시설을 안전하게 보호합니다.",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": "Korean"
    }
  };

  useSEO({
    title: "케어인슈 - 장기요양기관 배상책임보험 전문",
    description: "장기요양기관을 위한 전문 배상책임보험 서비스. 맞춤형 보험 설계와 신속한 사고 처리로 시설을 안전하게 보호합니다.",
    keywords: "장기요양기관보험, 배상책임보험, 요양시설보험, 케어인슈",
    ogImage: "https://public.readdy.ai/ai/img_res/afd0b6754315966cd7dbca14cd537030.jpg",
    schema
  });

  return (
    <>
      <div className="min-h-screen bg-white">
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
          <Hero />
          <Philosophy />
          <WhyCareInsure />
          <InsuranceDetails />
          <ProductIntro />
          <AccidentCriteria />
          <ClaimsProcess />
          <PremiumReasons />
          <PremiumStructure />
          <EvaluationSupport />
          <FAQ />
          <ConsultationForm />
          <Footer />
          <FloatingConsultButton />
        </Suspense>
      </div>
    </>
  );
}
